import { render, staticRenderFns } from "./viewPedido.vue?vue&type=template&id=4e2ee659&scoped=true&"
import script from "./viewPedido.vue?vue&type=script&lang=js&"
export * from "./viewPedido.vue?vue&type=script&lang=js&"
import style0 from "./viewPedido.vue?vue&type=style&index=0&id=4e2ee659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2ee659",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VFlex,VForm,VLayout,VTextField})
